import generalApi from '@/shared/api-rtk/api-list/generalApi.js'
import questionsApi from '@/shared/api-rtk/api-list/questionsApi.js'
import { chatApi } from '@/shared/api-rtk/api-list/chatApi.js'
import { authApi } from '@/shared/api-rtk/api-list/authApi.js'
import { profileApi } from '@/shared/api-rtk/api-list/profileApi.js'
import { newsApi } from '@/shared/api-rtk/api-list/newsApi.js'
import { blogApi } from '@/shared/api-rtk/api-list/blogApi.js'
import { productCatalogApi } from '@/shared/api-rtk/api-list/productCatalogApi.js'
import { ocApi } from './api-list/ocApi'

//general API
export const {
    useGetModulePageMutation,
    useProductsCatalogMutation,
    useGetReviewsMutation,
    useCreateReviewMutation,
    useGetCategoriesMutation,
    useNewProductsCatalogMutation,
    // useGetCategoryProductsMutation,
    useAboutTextMutation,
    useAboutSettingQuery,
    useGetSlidersHomeQuery,
    useGetInformationPageMutation,
    useGetVebinarsHomeMutation,
    useSignUpUserVebinarMutation,
    useGetAllNewsMutation,
    useGetAboutTextMutation,
} = generalApi

//news API
export const {
    useGetNewsMutation,
    useGetOtherNewsMutation,
    useGetOneNewsMutation,
} = newsApi

//blog API
export const {
    useGetBlogListMutation,
    useGetOneBlogItemMutation,
    useGetBlogProductMutation,
} = blogApi

//product catalog API
export const {
    useGetAllProductsMutation,
    useGetProductCatalogMutation,
    useGetImagesProductMutation,
    useGetOtherProductsMutation,
    useGetReviewsProductMutation,
    useGetQuestionsProductMutation,
    useGetCatalogFiltersMutation,
} = productCatalogApi

//questions API
export const {
    useGetQuestionsQuery,
    useGetOrderByQueryMutation,
    useSendFormMutation,
} = questionsApi

//chat API
export const { useAddChatQuestionMutation, useGetChatQuestionsMutation } =
    chatApi

//auth API
export const {
    useSignUpMutation,
    useSignInMutation,
    useCheckUserMutation,
    useSignInTgMutation,
    // useSessQuery,
    useLogoutMutation,
    useSignInVkMutation,
    useRecoveryRequestMutation,
    useRecoveryChangeMutation,
    useIsAdminQuery,
} = authApi

//profile API
export const {
    // useGetProfileInfoMutation,
    useChangeProfileInfoMutation,
    useGetHistoryOrdersMutation,
    useGetProductsOrderMutation,
    useChangePasswordMutation,
} = profileApi

export const { useGetCartItemsQuery } = ocApi
